<template>
    <div class="form-group" v-if="localValue">
        <label>
            <localized-text localizedKey="Carica nuova" text="Carica nuova"></localized-text>
        </label>
        <div>
            <template v-if="this.entityIdentifier">
                <file-input-multiple v-model="filesToUpload" v-if="!refresher"></file-input-multiple>
                <button class="btn btn-primary" @click="upload" :disabled="!filesToUpload">
                    <localized-text localizedKey="Carica" text="Carica"></localized-text>
                </button>
            </template>
            <template v-else>
                <localized-text localizedKey="Salva prima di caricare allegati" text="Salva prima di caricare allegati"></localized-text>
            </template>
        </div>
        <div class="mt-2">
            <div class="gallery">
                <div class="galleryItem" v-for="(item, i) in localValue">
                    <button class="moveLeft" @click="moveLeft(i)">
                        <icon-chevron-left></icon-chevron-left>
                    </button>
                    <img :src="item.publicUrl" />
                    <button class="position-absolute btn btn-sm btn-danger deleteButton" @click="removeImage(i)">
                        x
                    </button>
                    <button class="moveRight" @click="moveRight(i)">
                        <icon-chevron-right></icon-chevron-right>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">

import * as OM from '@/model';
import { Options, Vue } from 'vue-class-component';
import { Mixins, Prop, Watch } from 'vue-property-decorator';
import { UploadServices } from '@/services/UploadServices';
import WithModel from '@/mixins/withModel';

@Options({})
export default class galleryManager extends Mixins(WithModel) {

    @Prop() entityIdentifier: string;
    @Prop() addGalleryFunction: (vm: { entityIdentifier: string, attachment: OM.Attachment }) => void;
    @Prop() removeFunction: (index: number) => void;

    declare localValue: OM.Attachment[];

    filesToUpload: File[] = [];
    refresher: boolean = false;
    
    upload(){
        let proms = [];
        this.filesToUpload.forEach(file => {
            proms.push(
                UploadServices.UploadFile({
                    entityIdentifier: "",
                    file: file
                })
                .then(x => {
                    this.localValue.push(x);
                    if(this.addGalleryFunction){
                        this.addGalleryFunction({
                            entityIdentifier: this.entityIdentifier, 
                            attachment: x
                        })
                    }
                })
            )
        })
        Promise.all(proms)
        .then(x => {
            this.filesToUpload = [];
            this.refresher = true;
            setTimeout(() => {
                this.refresher = false;
            }, 0);
        })
    }

    moveLeft(index: number){
        if (index > 0 && index < this.localValue.length) {
            [this.localValue[index - 1], this.localValue[index]] = [this.localValue[index], this.localValue[index - 1]];
        }

    }

    moveRight(index: number){
        if (index >= 0 && index < this.localValue.length - 1) {
            [this.localValue[index], this.localValue[index + 1]] = [this.localValue[index + 1], this.localValue[index]];
        }
        
    }

    removeImage(index: number){
        if(this.removeFunction){
            this.removeFunction(index);
        }
        this.localValue.splice(index, 1);
    }

}
</script>
<style scoped>

button.moveLeft {
    position: absolute;
    bottom: 10px;
    left: 10px;
}

button.moveRight {
    position: absolute;
    bottom: 10px;
    right: 10px;
}

</style>